import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService, HttpService, ResponseMessage } from '@sdbn/appclient';
import { DialogService } from '@sdbn/common';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { TransportCreationProfile } from 'src/tmc-yard/client/model/station-usage.model';

@Component({
  selector: 'app-action-tablet-transport-creation-profile-details',
  templateUrl: './action-tablet-transport-creation-profile-details.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-details.component.scss']
})
export class ActionTabletTransportCreationProfileDetailsComponent {
  
  @Input() transportCreationProfile!: TransportCreationProfile;
  
  @Output() transportCreationProfileSelected = new EventEmitter<TransportCreationProfile>(); 
  
  profileClicked() {
    this.transportCreationProfileSelected.emit(this.transportCreationProfile);
  }
  
}
